/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmAgendaFunkce extends GContentBase<SeznamAdmAgendaFunkceObj> {
        private seznamObj: SeznamAdmAgendaFunkceObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmAgendaFunkceObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmAgendaFunkceNew",
                contentCaption: "jres:33000769", //RC 33000769 : P�i�azen� agendy ISZR funkc�m 
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{agenda} - {ixs_fun_txt}"
                },
                gridSettings: {
                    columnOrder: `agenda,agenda_txt,ixs_fun_txt,s_prist_aiseo,s_prist_isep,s_prist_aisc,${this.isPovolenaEvidenceOP == true ? "s_prist_aiseop," : "" }dat_zmena,zmenu_prov_txt`,
                    defaultSort: "agenda"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmAgendaFunkceObj extends GAdmSeznamBase {
        isPovolenaEvidenceOP: boolean;
        private povoleniRole: boolean;

        create() {
            this.cnt.showFlash({
                content: "jres:33000773", //RC 33000773 : Toto je pouze p�ehled, nastaven� agend a rol� je mo�n� na detailu funk�n�ho m�sta.
                state: "info"
            })
        }

        openDetail(data: any, isNew: boolean) {
            //$.content().navigate(["Gordic.Adm.WebControls.DetailAdmAgendaFunkce", {
            //    currentFilter: this.filterData,
            //    gridRc: new Gordic.Components.GridRC(this.grid)
            //}], {
            //    ID: "DetailAdmAgendaFunkce",
            //    newRecord: isNew,
            //    ixs_fun: isNew == true ? null : data.ixs_fun,
            //    agenda: isNew == true ? null : data.agenda
            //})
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actOpenAgendoveRole: {
                    caption: "jres:33000774", //RC 33000774 : Povolen� role funkci 
                    disabled: !this.povoleniRole,
                    icon: "fa-link",
                    run: (ev, ctx) => {
                        this.openSeznamAdmAgendovaRoleFunkce()
                    }
                }
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar([
                //"actOpenDetail*",
                //"actNewDetail*",
                "actAddToComparison*",
                "actOpenDialogVyberovaSkupina*",
                {
                    favorite: true, type: "static", caption: "jres:33000138", icon: "fa-link", children: [
                        {
                            action: this.cnt.actions.actOpenAgendoveRole
                        }
                    ]
                }
            ]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*", "actOpenDialogVyberovaSkupina*", "actOpenAgendoveRole*"])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:33000757").addField("gselectbox", Gordic.Prefabs.Select.szrsage(), { //RC 33000757 : Agenda
                name: "agenda",
                model: "model.agenda=value.agenda",
                dropdown: true,
                serverFilters: {
                    aktivita: [100, 300, 500, 600, 900]
                }
            }).addRow("jres:29802552").addField("gselectbox", Gordic.Prefabs.Select.ginsfun(), {
                name: "ixs_fun",
                model: "model.ixs_fun=value.ixs_fun",
                dropdown: true,
                serverFilters: {
                    aktivita: [100, 300, 500, 600, 900]
                }
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {
        }

        applydata(filterData: any) {
            this.cnt.isl.AdmAgendaFunkce.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.view.process({
                    ac: new Gordic.Data.Grouping([{
                        defaultState: "open",
                        hash: (meta, rows) => {
                            return `<span class='adm-no-bold'>jres:33000753:</span> <b>${meta.data.agenda} - ${meta.data.agenda_txt}</b>`
                        }
                    }])
                })
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            this.cnt.actions.actOpenAgendoveRole?.update({ enabled: objArr.count > 0 && this.povoleniRole })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: `${data.ixs_fun}#${data.agenda}#`,
                nazev: `${data.ixs_fun_txt} x ${data.agenda}`
            }
        }

        private openSeznamAdmAgendovaRoleFunkce() {
            var activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmAgendovaRoleFunkce", {
                    ixs_fun: activeRow.ixs_fun,
                    agenda: activeRow.agenda
                }])
        }
    }
}